import React, { useContext, useMemo } from 'react';
import { CardFooter } from '../../shared/card/card-footer';
import { DefaultLoadingComponent } from '../../../shared/utils/loader/default-loading-component';
import { LoaderContext } from '../../../shared/utils/loader/loader-wrapper';
import './card-clients.scss';
export var CardClientDetailsFooter = function (_a) {
    var handleExpand = _a.handleExpand, expanded = _a.expanded, existingCases = _a.existingCases;
    var data = useContext(LoaderContext);
    var isLoading = useMemo(function () { return data.isLoading; }, [data.isLoading]);
    return (React.createElement(CardFooter, null,
        React.createElement("footer", null, isLoading ? (React.createElement(DefaultLoadingComponent, null)) : (existingCases > 3 && (React.createElement("button", { onClick: handleExpand, className: "notes__text u-fs-2" },
            React.createElement("b", null, expanded ? 'See less' : 'See more')))))));
};
